import { toast } from "react-toastify";
import Client, { ClientWithCounts, IClientQueryParams } from "models/client";
import { PaginatedResult } from "models/queryable";
import { buildQueryString } from "utils/query-string";

export const getClients = async (query?: IClientQueryParams): Promise<PaginatedResult<ClientWithCounts> | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/client${buildQueryString(query)}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as PaginatedResult<ClientWithCounts>;

    } catch (err: any) {
        toast.error(err.message ?? "Error getting clients");
        return null;
    }
}

export const getClient = async (clientId: string): Promise<Client | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/client/${clientId}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as Client;

    } catch (err: any) {
        toast.error(err.message ?? "Error getting client");
        return null;
    }
}
